import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Home,
  User,
  Tickets,
  Building2,
  BarChart3,
  LogIn,
} from 'lucide-react';
import './MobileTabBar.css';

// Bottom nav for <768px; PublicNavbar covers wider viewports.

const SIGNED_OUT_TABS = [
  { to: '/', label: 'Home', Icon: Home, match: 'exact' },
  { to: '/my-bookings', label: 'My bookings', Icon: Tickets },
  { to: '/login', label: 'Log in', Icon: LogIn },
];

const RENTER_TABS = [
  { to: '/', label: 'Home', Icon: Home, match: 'exact' },
  { to: '/my-bookings', label: 'My bookings', Icon: Tickets },
  { to: '/profile', label: 'Profile', Icon: User },
];

const OPERATOR_TABS = [
  { to: '/', label: 'Home', Icon: Home, match: 'exact' },
  { to: '/bookings', label: 'Bookings', Icon: Tickets },
  { to: '/organization', label: 'Organization', Icon: Building2 },
  { to: '/operator-profile', label: 'Analytics', Icon: BarChart3 },
  { to: '/profile', label: 'Profile', Icon: User },
];

const isTabActive = (pathname, tab) =>
  tab.match === 'exact' ? pathname === tab.to : pathname.startsWith(tab.to);

const MobileTabBar = () => {
  const { currentUser, currentUserObject, isOperator } = useAuth();
  const { pathname } = useLocation();

  const signedIn = currentUser && currentUserObject;
  const tabs = !signedIn ? SIGNED_OUT_TABS : isOperator ? OPERATOR_TABS : RENTER_TABS;

  return (
    <nav className="mobile-tab-bar d-md-none" aria-label="Primary">
      {tabs.map((tab) => {
        const active = isTabActive(pathname, tab);
        const { Icon } = tab;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`mobile-tab-bar__item${active ? ' is-active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={22} strokeWidth={active ? 2.4 : 2} aria-hidden="true" />
            <span className="visually-hidden">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
